/** A quiet invitation becomes eligible only after a clean, completed edition. */
export function captainReminderEligible(state: {
  completedEpisodeId: string | null;
  episodeId: string;
  available: boolean;
  comic: boolean;
  guestState: "idle" | "queued" | "active";
  playing: boolean;
  paused: boolean;
  reducedMotion: boolean;
  recording: boolean;
  busy: boolean;
}): boolean {
  return !!state.completedEpisodeId && state.completedEpisodeId === state.episodeId &&
    state.available && state.comic && state.guestState === "idle" && !state.playing && !state.paused &&
    !state.reducedMotion && !state.recording && !state.busy;
}
